import {  Input } from "@storybook";
import { useRecoilState } from "recoil";
import { EMBEDED_FORM, EmbededFormState } from "./stores/state";
import { useEffect } from "react";

interface ICombinedInput {
  handleChange?: any;
}
export const CombinedInput = ({ handleChange }: ICombinedInput) => {
  const [form, setForm] = useRecoilState(EmbededFormState);
  const isPhone = (value: string) =>
    /^-?\d+(\.\d+)?$/.test(value.replace(/\s+/g, ""));
  const clean = (value: string) => value.replace(/\s+/g, "");

  const handlePhoneInput = (
    rawValue: string,
    label: string,
    countryCode?: string
  ) => {
    const phoneObj = form;
    let inputVal = rawValue;
    let validationInput = rawValue;

    if (EMBEDED_FORM.numberFormatter) {
      const formattedData = EMBEDED_FORM.numberFormatter({
        value: rawValue,
        countryCode: phoneObj?.countryCode ?? "+1",
      });
      inputVal = formattedData.formatted ?? rawValue;
      validationInput = formattedData.validationInput ?? rawValue;
    }

    const newForm = {
      ...form,
      value: inputVal,
      isCountryCodeVisible: true,
      name: label,
      countryCode: countryCode || form.countryCode,
    };

    if (EMBEDED_FORM.numberValidation) {
      const { isError, errorMessage } =
        EMBEDED_FORM.numberValidation(validationInput);
      newForm.isError = isError;
      newForm.errorMessage = errorMessage;
    }
    // eslint-disable-next-line no-console
    console.log({ newForm, label });
    handleChange?.(newForm);
    setForm(() => {
      return newForm;
    });
  };

  const handleEmailInput = (cleanedValue: string, label: string) => {
    const newForm = {
      ...form,
      value: cleanedValue,
      isCountryCodeVisible: false,
      name: label,
    };
    if (EMBEDED_FORM.emailValidation) {
      const { isError, errorMessage } =
        EMBEDED_FORM.emailValidation(cleanedValue);
      newForm.isError = isError;
      newForm.errorMessage = errorMessage;
    }
    // eslint-disable-next-line no-console
    console.log({ newForm, label });
    handleChange?.(newForm);

    setForm(() => {
      return newForm;
    });
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const cleanedValue = clean(value);
    const label = isPhone(cleanedValue) ? "phone" : "email";
    if (label === "phone" && value.length > 3) {
      handlePhoneInput(value, label);
    } else {
      handleEmailInput(cleanedValue, label);
    }
  };

  useEffect(() => {
    if (form.value) {
      handleChange?.(form);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Input
      {...form}
      handleChange={handleChangeInput}
      handleChangeCountry={(e: any) =>
        handlePhoneInput(form.value as any, form.name, e.label)
      }
    />
  );
};
